import { Component, AfterContentInit, ElementRef, OnInit, OnDestroy, Optional } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseFormComponent, BaseFormHeaderInfo } from '../tasks/baseFormComponent/baseForm.component';
import { of, Observable } from 'rxjs';
import { FormConfig } from '../components/forms/form.objects';

import { ResultTypeDTO, CompanyProjectDTO, CompanyDTO } from '../api/plyca-dtos-v2';
import { getSimpleIdentifierFromString, I18nData } from '../api/plyca-dtos';

import { DatePipe } from '@angular/common';

import * as lodash from 'lodash';
import { PropertyService } from '../properties/property.service';
import { DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { CompanyAdminComponent, ViewDTOModal } from '../company/companyAdmin.component';
import { finalize } from 'rxjs/operators';




export class CompanyProjectModel {

  dto: CompanyProjectDTO;
  ui: {
    isContextWork?: boolean,
  }
}

@Component({
  selector: 'companyproject-form',
  templateUrl: '../tasks/baseFormComponent/baseForm.template.html', providers: [DatePipe]
})
export class CompanyProjectComponent
  extends BaseFormComponent<CompanyProjectDTO, CompanyProjectModel>
  implements OnInit, OnDestroy, AfterContentInit {


  headerService: any;
  private identifier: string;

  private rutaInicio: string;




  constructor(
    elem: ElementRef,
    @Optional() protected activatedRoute: ActivatedRoute,
    private router: Router,
    private datePipe: DatePipe,
    private propertyService: PropertyService
  ) {
    super(elem);
    this.waitService.startWaiting();
    this.subscribe(this.activatedRoute.params, params => {
      this.identifier = params['id'];

    })

    this.waitService.cancelWaiting();

  }




  ngAfterContentInit(): void {

  }

  getFormSettingURL(): string {
    return 'ril/companyProjectInterfaceSettings.json';
  }


  close() { }

  dtoToModel(dto: CompanyProjectDTO): Observable<CompanyProjectModel> {
    let model = new CompanyProjectModel();
    model.dto = dto;
    model.ui = {
      isContextWork: false
    }

    /*if (this.task !== undefined) {
      if (this.task.work) {
        if (this.task.work.companyProject === undefined) {
          this.uiService.showMessage(
            'Se ha producido un error en la carga de datos del contrato. ' +
            'Consulte con el administrador. ',
            'Aviso',
            'errorStyle'
          );
        }
        // if (model.dto.reloadProject === undefined || !model.dto.reloadProject) {
        model.dto = this.task.work.companyProject;
      }
      model.ui.isContextWork = true;
    }*/

    let modelObs: Observable<CompanyProjectModel>;
    modelObs = of(model);
    return modelObs;
  }

  modelToDTO(model: CompanyProjectModel): CompanyProjectDTO {


    if (this.task) {
      //this.task.work.companyProject = model.dto;

    }
    return model.dto;
  }

  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();

    headerInfo.titleKey = 'Expediente RIL';
    headerInfo.titleIcon = 'fas fa-envelope-open-text';

    return headerInfo;
  }
  getObjectIdentifier(): string {
    let identifier: string;
    if (this.task) {
      //identifier = this.task.work.companyProject.identifier;;
    } else if (this.identifier) {
      identifier = this.identifier;
    } else {
      // nuevo contrato
      identifier = 'new';
    }
    return identifier;
  }



  getServiceURL(): string {
    return this.configuration.COMPANYPROJECT_SERVICE_URL;

  }



  openWindowCompany(row: CompanyDTO, esAlta: boolean) {

    let config: DynamicDialogConfig = {
      header: this.translate.instant('CompanyAdmin.title'),
      width: '70%',
      style: { overflow: 'scroll' },
      styleClass: 'formEdition'

    };

    config['item'] = new ViewDTOModal(row, 'companyDetailISettings.json');
    config['esAltaEmpresa'] = esAlta;

    const ref = this.dialogService.open(
      CompanyAdminComponent,
      config
    );


    this.subscribe(ref.onClose,
      result => {

        //this.load();

      });
  }

  initHeaderActions() {
    this.headerActionsService.clearActions();
    this.subscribe(this.headerActionsService
      .addAction('Editar datos empresa ', 'fas fa-check', 'btn-primary', this.model.dto.identifier !== undefined)
      , (() => {
        this.openWindowCompany(this.model.dto.company, false);
      }));
    this.subscribe(this.headerActionsService
      .addAction('Publicar Expediente RIL ', 'fas fa-check', 'btn-primary', this.model.dto.identifier !== undefined)
      , (() => {
        this.subscribe(this.plycaService.republicateCompanyProject(this.model.dto).pipe(
          finalize(() => {
            this.uiService.showMessage(this.translate.instant('CompanyList.ril.republicate'), 'Info', 'successStyle');

          })
        ));
      }));
    this.subscribe(this.headerActionsService
      .addAction('Verificar', 'fas fa-check', 'btn-primary', this.model.dto.identifier === undefined || this.model.ui.isContextWork)
      , (() => {
        this.validateProject();
      }));
    this.subscribe(this.headerActionsService
      .addAction('Guardar', 'fas fa-save', 'btn-primary', this.model.dto.identifier === undefined || this.model.ui.isContextWork)
      , (
        () => {
          let dto = this.modelToDTO(lodash.cloneDeep(this.model));
          if (this.task !== undefined) {
            this.subscribe(this.saveIfValid(),

              (result: any) => {

                this.waitService.cancelWaiting();

              });
          } else {
            this.waitService.startWaiting();

            this.subscribe(this.validateContext(false, dto, this.model.dto.identifier ? 'Update' : 'Insert')
              , result => {
                if (result.result === ResultTypeDTO.ERROR) {
                  this.waitService.cancelWaiting();
                  this.uiService.showConfirmMessage({
                    message: this.translate.instant('Contracts.Header.confirmSave'),
                    header: this.translate.instant('General.confirm.text'),
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                      console.log('Grabando contrato...');
                      this.waitService.startWaiting();
                      this.subscribe(this.saveContext(false, dto, this.model.dto.identifier ? 'Update' : 'Insert'),
                        _model => {
                          this.goToDossierInfo(_model);
                          //this.goToControlPanel();
                        });

                    },
                    reject: () => {
                      console.log('No hace nada...');
                    }

                  });
                } else if (result.result === ResultTypeDTO.OK) {
                  this.subscribe(this.saveContext(false, dto, this.model.dto.identifier ? 'Update' : 'Insert'), _model => {
                    this.waitService.startWaiting();

                    this.goToDossierInfo(_model);
                    //this.goToControlPanel();
                    this.waitService.cancelWaiting();
                  });
                } else {
                  // Error de validación FATAL
                  this.waitService.cancelWaiting();
                }
              }
            )
          }
        }));
    //if (this.model.dto.identifier === undefined || this.model.ui.isContextWork) {
    this.headerActionsService.addDivider();
    this.addBackAction();
    //}
  }

  goToDossierInfo(_company: CompanyProjectDTO) {
    this.router.navigate(['dossierInfo/' + _company.division.project.identifier], {
      queryParams: { component: 'GENERAL_INFO' }
    });
    // this.waitService.cancelWaiting();
  }

  goToControlPanel() {
    this.router.navigate(['controlPanel'], {
    });
  }





  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {

    return super.configureFormConfig(formConfig);
  }



  validateProject() {
    this.subscribe(this.validate(), (result => {
      if (result.result === ResultTypeDTO.OK) {

        this.uiService.showMessage(
          "S'' ha validat correctament.",
          'Aviso',
          'errorStyle'
        );
      }
    }))
  }



  ngOnDestroy() {
    this.datePipe = null;
    super.ngOnDestroy();
  }


}
